import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Popup from "../../../ResuableCompoment/Popup";
import useApi from "../../../CustomHooks/useApi";
import BankSelect from "../../../ResuableCompoment/BankSelect";
import { useSelector, useDispatch } from "react-redux";
import { fetchAepsBalance, fetchSettlementBalance, fetchWalletBalance } from "../../../Store/Slices/WalletSlice";
import bankList from "../DMT/Addbeneficiary/banklist.json";

const AepsAddBeneficiary = () => {

  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const remitter_mobile_number = useSelector((state) => state.auth.remitterData?.remitter_phone);
  const remitter_fullname = useSelector((state) => state.auth.remitterData?.remitter_name);
  const username = useSelector((store) => store.auth.employeeDetails.username);
  const [bankSearch, setBankSearch] = useState("");
  const [showBankList, setShowBankList] = useState(false);

  const impsType = useSelector(
    (state) => state.auth.remitterData?.type // "IMPS1" | "IMPS2"
  );

  console.log("impassstyeyee", impsType)

  const [showOtpInput, setShowOtpInput] = useState(false);
  const [otp, setOtp] = useState("");
  const [otpToken, setOtpToken] = useState("");
  const [selectedBankIfsc, setSelectedBankIfsc] = useState("");

  const [bank, setBank] = useState("");
  const [ifscCode, setIfscCode] = useState("");
  const [bankcode, setBankcode] = useState("");
  const [accountHolderName, setAccountHolderName] = useState("");
  const [accountNumber, setAccountNumber] = useState("");
  const [confirmAccountNumber, setConfirmAccountNumber] = useState("");
  const [mpin, setMpin] = useState("");
  const [mobileNumber, setMobileNumber] = useState("");
  const [errors, setErrors] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [selectedBankId, setSelectedBankId] = useState("");
  const [selectedBankName, setSelectedBankName] = useState("");

  const [popupMessage, setPopupMessage] = useState("");
  const [popupType, setPopupType] = useState("");
  const [showPopup, setShowPopup] = useState(false);
  const [navigateTo, setNavigateTo] = useState(null);
  const [navigateState, setNavigateState] = useState(null);

  const showPopupMessage = (message, type, navigateTo = null, navigateState = null) => {
    setPopupMessage(message);
    setPopupType(type);
    setNavigateTo(navigateTo);
    setNavigateState(navigateState);
    setShowPopup(true);
  };

  const txnId = `DMT${new Date().toISOString().replace(/[-:.TZ]/g, "").slice(0, 14)}${Math.floor(1000 + Math.random() * 9000)}`;

  const { callApi: addbeni } = useApi("/dmt/add/beneficiary", "POST");

  // const handleConfirm = async () => {
  //   let newErrors = {};

  //   // if (!bank) newErrors.bank = "Please select a bank.";
  //   if (!selectedBankId) newErrors.bank = "Please select a bank.";

  //   if (!accountHolderName) {
  //     newErrors.accountHolderName = "Account Holder Name is required.";
  //   } else if (!/^[A-Za-z\s]+$/.test(accountHolderName)) {
  //     newErrors.accountHolderName =
  //       "Account Holder Name can contain only alphabets and spaces.";
  //   }

  //   if (!accountNumber) {
  //     newErrors.accountNumber = "Account Number is required.";
  //   } else if (accountNumber.length < 6 || accountNumber.length > 20) {
  //     newErrors.accountNumber = "Account Number must be between 6 and 20 digits.";
  //   }

  //   if (!confirmAccountNumber) {
  //     newErrors.confirmAccountNumber = "Please confirm your Account Number.";
  //   } else if (confirmAccountNumber.length < 6 || confirmAccountNumber.length > 20) {
  //     newErrors.confirmAccountNumber = "Confirm Account Number must be between 6 and 20 digits.";
  //   } else if (accountNumber !== confirmAccountNumber) {
  //     newErrors.confirmAccountNumber = "Account numbers do not match.";
  //   }


  //   if (!ifscCode) newErrors.ifscCode = "IFSC Code is required.";

  //   if (!mobileNumber) newErrors.mobileNumber = "Mobile Number is required.";
  //   else if (!/^\d{10}$/.test(mobileNumber)) newErrors.mobileNumber = "Invalid Mobile Number. It should be 10 digits.";

  //   if (!mpin) {
  //     newErrors.mpin = "MPIN is required.";
  //   } else if (!/^\d{6}$/.test(mpin)) {
  //     newErrors.mpin = "MPIN must be exactly 6 digits.";
  //   }

  //   setErrors(newErrors);

  //   if (Object.keys(newErrors).length > 0) {
  //     return;
  //   }

  //   setIsLoading(true);

  //   try {
  //     const requestBody = {
  //       remitterPhoneNumber: remitter_mobile_number,
  //       remitterName: remitter_fullname,
  //       beneficiaryName: accountHolderName,
  //       beneficiaryPhoneNumber: mobileNumber,
  //       bankName: bank,
  //       bankIfscCode: ifscCode,
  //       accountNumber: accountNumber,
  //       paymentMode: "IMPS",
  //       bank_code: bankcode,
  //       user_name: username,
  //       mpin: mpin,
  //     };

  //     const requestHeaders = {
  //       Cookie: "JSESSIONID=A839C7E986CC50D62049244503766A47",
  //     };



  //     const data = await addbeni(requestBody, null, requestHeaders);

  //     console.log("dataa", data);

  //     if (data.beneficiary_id) {
  //       showPopupMessage(
  //         `Beneficiary Details : BeneficiaryId : ${data.beneficiary_id}, BeneficiaryStatus: ${data.beneficiary_status}, BeneficiaryName : ${data.beneficiary_name}, BeneficiaryIfscCode : ${data.beneficiary_ifsc_code}`,
  //         "success",
  //         "/remittance");
  //       return;
  //     } else if (data.error_code == "202") {
  //       showPopupMessage(`Error: ${data.message}`, "error");
  //     } else if (data.error_code === "DMT000") {
  //       showPopupMessage(`Error: ${data.message}`, "error");
  //     } else {
  //       showPopupMessage(`Error: ${data.message}`, "error");
  //     }
  //   } catch (error) {
  //     showPopupMessage("Something went wrong. Please try again later.", "error");
  //   } finally {
  //     setIsLoading(false);
  //     dispatch(fetchWalletBalance());
  //   }
  // };

  const handleConfirm = async () => {
    const newErrors = {};

    // ---------- COMMON ----------
    if (!accountHolderName) {
      newErrors.accountHolderName = "Account Holder Name is required.";
    } else if (!/^[A-Za-z\s]+$/.test(accountHolderName)) {
      newErrors.accountHolderName =
        "Account Holder Name can contain only alphabets and spaces.";
    }

    if (!accountNumber || accountNumber.length < 6 || accountNumber.length > 20) {
      newErrors.accountNumber =
        "Account Number must be between 6 and 20 digits.";
    }

    // if (confirmAccountNumber !== accountNumber) {
    //   newErrors.confirmAccountNumber = "Account numbers do not match.";
    // }

    if (!mobileNumber || !/^\d{10}$/.test(mobileNumber)) {
      newErrors.mobileNumber = "Enter a valid 10-digit mobile number.";
    }

    if (!mpin || !/^\d{6}$/.test(mpin)) {
      newErrors.mpin = "MPIN must be exactly 6 digits.";
    }

    // ---------- IMPS2 (ORIGINAL) ----------
    if (impsType === "IMPS2") {
      if (!bank) newErrors.bank = "Please select a bank";
      if (!ifscCode) newErrors.ifscCode = "IFSC code is required";
    }

    // ---------- IMPS1 (NEW) ----------
    if (impsType === "IMPS1") {
      if (!selectedBankId) newErrors.bank = "Please select a bank";
      // if (!selectedBankIfsc)
      //   newErrors.ifscCode = "Selected bank does not have a valid IFSC";
      if (impsType === "IMPS1") {
        if (!selectedBankId) {
          newErrors.bank = "Please select a bank";
        }
      }
    }

    // ---------- OTP (IMPS1 STEP 2) ----------
    if (impsType === "IMPS1" && showOtpInput) {
      if (!otp || !/^\d{4}(\d{2})?$/.test(otp)) {
        newErrors.otp = "Enter a valid 4 or 6 digit OTP.";
      }
    }

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    setIsLoading(true);

    try {
      // ================= IMPS2 (ORIGINAL PAYLOAD) =================
      if (impsType === "IMPS2") {
        const imps2Payload = {
          remitterPhoneNumber: remitter_mobile_number,
          remitterName: remitter_fullname,
          beneficiaryName: accountHolderName,
          beneficiaryPhoneNumber: mobileNumber,
          bankName: bank,
          bankIfscCode: ifscCode,
          accountNumber,
          user_name: username,
          mpin,
          bank_code: bankcode,
          type: "IMPS2"
        };

        const res = await addbeni(imps2Payload);

        if (res?.beneficiary_id) {
          setPopupMessage("Beneficiary added successfully.");
          setPopupType("success");
          setNavigateTo("/aepsremitter");
          setShowPopup(true);
          return;
        }

        throw new Error(res?.message || "Failed to add beneficiary");
      }

      // ================= IMPS1 (NEW PAYLOAD) =================
      const imps1Payload = {
        remitterPhoneNumber: remitter_mobile_number,
        remitterName: remitter_fullname,
        beneficiaryName: accountHolderName,
        beneficiaryPhoneNumber: mobileNumber,
        accountNumber,
        bankName: selectedBankName,
        bank_code: selectedBankId,
        bankIfscCode: selectedBankIfsc,
        user_name: username,
        mpin,
        type: "IMPS2"
      };

      // ===== IMPS1 STEP 1: SEND OTP =====
      // if (!showOtpInput) {
      //   const res = await addbeni({
      //     ...imps1Payload,
      //     otp: null,
      //     token: null
      //   });

      //   if (res?.error_code === "DMT001") {
      //     setOtpToken(res?.action_params?.token || "");
      //     setShowOtpInput(true);
      //     return;
      //   }

      //   if (res?.token) {
      //     setOtpToken(res.token);
      //     setShowOtpInput(true);
      //     setPopupMessage("OTP sent. Please enter OTP to continue.");
      //     setPopupType("info");
      //     setShowPopup(true);
      //     return;
      //   }

      //   throw new Error(res?.message || "Failed to send OTP");
      // }

      // ===== IMPS1 STEP 2: VERIFY OTP =====
      const res = await addbeni({
        ...imps1Payload
      });

      if (res?.beneficiary_id) {
        setPopupMessage("Beneficiary added successfully.");
        setPopupType("success");
        setNavigateTo("/aepsremitter");
        setShowPopup(true);
        return;
      }

      throw new Error(res?.message || "OTP verification failed");
    } catch (err) {
      setPopupMessage(err.message || "Something went wrong.");
      setPopupType("error");
      setShowPopup(true);
    } finally {
      setIsLoading(false);
      dispatch(fetchWalletBalance());
      dispatch(fetchAepsBalance());
      dispatch(fetchSettlementBalance());
    }
  };

  const handleCancel = () => {
    navigate("/aepsremitter");
  };

  const handleChange = (fieldName, value) => {
    const sanitizedValue =
      fieldName === "mobileNumber" || fieldName.includes("Account")
        ? value.replace(/\D/g, "")
        : value;

    switch (fieldName) {
      case "accountHolderName":
        setAccountHolderName(sanitizedValue);
        break;
      case "accountNumber":
        setAccountNumber(sanitizedValue);
        break;
      case "confirmAccountNumber":
        setConfirmAccountNumber(sanitizedValue);
        break;
      case "mobileNumber":
        setMobileNumber(sanitizedValue);
        break;
      case "mpin":
        setMpin(sanitizedValue);
        break;
      default:
        break;
    }

    setErrors((prevErrors) => ({ ...prevErrors, [fieldName]: "" }));
  };


  // return (
  //   <div className="w-full max-w-[50rem] mx-auto bg-white p-8 rounded-lg shadow-md mt-10">
  //     <h2 className="text-2xl font-semibold text-center mb-4">Add New Beneficiary</h2>

  //     <div className="bg-green-100 text-green-700 text-center text-sm py-2 rounded mb-6">
  //       "Add a beneficiary and make sure your funds have a happy landing!"
  //     </div>

  //     <div className="overflow-y-auto">
  //       <form className="space-y-4">
  //         <div>
  //           <BankSelect
  //             ifscInput={ifscCode}
  //             onIfscChange={(e) => {
  //               setIfscCode(e.target.value.toUpperCase());
  //               setErrors((prevErrors) => ({ ...prevErrors, ifscCode: '' }));
  //             }}
  //             onSelect={(selected) => {
  //               setBank(selected.bank_name);
  //               setBankcode(selected.bank_code);
  //             }}
  //           />
  //           {errors.ifscCode && <p className="text-red-500 text-xs mt-1">{errors.ifscCode}</p>}
  //         </div>

  //         <div>
  //           <input
  //             type="text"
  //             name="disable-autofill-name"
  //             value={accountHolderName}
  //             onChange={(e) => handleChange("accountHolderName", e.target.value)}
  //             placeholder="Account Holder Name"
  //             className="w-full border border-gray-300 rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-green-500"
  //           />
  //           {errors.accountHolderName && <p className="text-red-500 text-xs mt-1">{errors.accountHolderName}</p>}
  //         </div>

  //         <div>
  //           <input
  //             type="text"
  //             name="disable-autofill-account"
  //             value={accountNumber}
  //             onPaste={handlePaste}
  //             maxLength={20}
  //             onChange={(e) => handleChange("accountNumber", e.target.value)}
  //             placeholder="Account Number"
  //             className="w-full border border-gray-300 rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-green-500"
  //           />
  //           {errors.accountNumber && <p className="text-red-500 text-xs mt-1">{errors.accountNumber}</p>}
  //         </div>

  //         <div>
  //           <input
  //             type="text"
  //             name="disable-autofill-confirm-account"
  //             value={confirmAccountNumber}
  //             onPaste={handlePaste}
  //             maxLength={20}
  //             onChange={(e) => handleChange("confirmAccountNumber", e.target.value)}
  //             placeholder="Confirm Account Number"
  //             className="w-full border border-gray-300 rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-green-500"
  //           />
  //           {errors.confirmAccountNumber && <p className="text-red-500 text-xs mt-1">{errors.confirmAccountNumber}</p>}
  //         </div>

  //         <div>
  //           <input
  //             type="text"
  //             name="disable-autofill-mobile"
  //             value={mobileNumber}
  //             maxLength={10}
  //             onChange={(e) => handleChange("mobileNumber", e.target.value)}
  //             placeholder="Enter mobile number"
  //             className="w-full border border-gray-300 rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-green-500"
  //           />
  //           {errors.mobileNumber && <p className="text-red-500 text-xs mt-1">{errors.mobileNumber}</p>}
  //         </div>

  //         <div>
  //           <input
  //             type="password"
  //             autoComplete="new-password"
  //             name="disable-autofill-mpin"
  //             value={mpin}
  //             maxLength={6}
  //             onChange={(e) => handleChange("mpin", e.target.value)}
  //             placeholder="Enter MPIN"
  //             className="w-full border border-gray-300 rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-green-500"
  //           />
  //           {errors.mpin && <p className="text-red-500 text-xs mt-1">{errors.mpin}</p>}
  //         </div>
  //       </form>

  //       <div className="flex justify-between pt-4">
  //         <button
  //           type="button"
  //           className="w-[45%] py-2 border border-green-600 text-green-600 rounded hover:bg-green-50"
  //           onClick={handleCancel}
  //         >
  //           Cancel
  //         </button>
  //         <button
  //           type="submit"
  //           onClick={handleConfirm}
  //           disabled={isLoading}
  //           className={`w-[45%] py-2 rounded text-white transition duration-200
  //   ${isLoading
  //               ? 'bg-gray-400 cursor-not-allowed'
  //               : 'bg-green-600 hover:bg-green-700 cursor-pointer'}
  // `}
  //         >
  //           {isLoading ? "Verifying..." : "Verify"}
  //         </button>
  //       </div>
  //       {showPopup && (
  //         <Popup
  //           message={popupMessage}
  //           type={popupType}
  //           onClose={() => {
  //             setShowPopup(false);
  //             setNavigateTo(null);
  //             setNavigateState(null);
  //           }}
  //           navigateTo={navigateTo}
  //           navigateState={navigateState}
  //           showchildren={false}
  //         />
  //       )}
  //     </div>
  //   </div>
  // );

  return (
    <div className="max-w-6xl mx-auto mt-10 grid grid-cols-1 lg:grid-cols-3 gap-8">

      {/* ===== LEFT INFO PANEL ===== */}
      <div className="lg:col-span-1 rounded-2xl p-6 bg-gradient-to-br from-indigo-600 to-indigo-800 text-white shadow-lg">
        <h2 className="text-xl font-semibold mb-3">
          Add Beneficiary
        </h2>

        <p className="text-sm text-indigo-100 mb-6">
          Enter beneficiary bank details carefully.
          Transfers can only be made after successful verification.
        </p>

        <ul className="space-y-3 text-sm">
          <li className="flex gap-2">
            <span>✔</span>
            <span>Account number must be correct</span>
          </li>
          <li className="flex gap-2">
            <span>✔</span>
            <span>IFSC determines the bank</span>
          </li>
          <li className="flex gap-2">
            <span>✔</span>
            <span>MPIN is required for security</span>
          </li>
        </ul>
      </div>

      {/* ===== RIGHT FORM PANEL ===== */}
      <div className="lg:col-span-2 bg-white rounded-2xl shadow-lg p-6">

        {/* SECTION: BANK DETAILS */}
        <div className="mb-6">
          <h3 className="text-sm font-semibold text-slate-700 mb-4">
            Bank Details
          </h3>

          <div className="space-y-4">
            {/* <BankSelect
              ifscInput={ifscCode}
              onIfscChange={(e) => {
                setIfscCode(e.target.value.toUpperCase());
                setErrors((prev) => ({ ...prev, ifscCode: "" }));
              }}
              onSelect={(selected) => {
                setBank(selected.bank_name);
                setBankcode(selected.bank_code);
                setErrors((prev) => ({ ...prev, bank: "" }));
              }}
            />
            {errors.bank && (
              <p className="text-red-500 text-xs mt-1">
                {errors.bank}
              </p>
            )} */}
            {impsType === "IMPS2" && (
              <>
                <BankSelect
                  ifscInput={ifscCode}
                  onIfscChange={(e) => {
                    setIfscCode(e.target.value.toUpperCase());
                    setErrors((prev) => ({ ...prev, ifscCode: "" }));
                  }}
                  onSelect={(selected) => {
                    setBank(selected.bank_name);
                    setBankcode(selected.bank_code);
                    setErrors((prev) => ({ ...prev, bank: "" }));
                  }}
                />

                {errors.bank && (
                  <p className="text-red-500 text-xs mt-1">
                    {errors.bank}
                  </p>
                )}
              </>
            )}
            {/* <select
              value={selectedBankId}
              onChange={(e) => {
  const value = e.target.value;

  if (!value) {
    setSelectedBankId("");
    setSelectedBankName("");
    setSelectedBankIfsc("");
    return;
  }

  const bank = bankList.data.find((b) => b.bank_id === value);
  if (bank) {
    setSelectedBankId(bank.bank_id);
    setSelectedBankName(bank.bank_name);
    setSelectedBankIfsc(bank.bank_ifsc); // ✅ IMPORTANT
    setErrors((prev) => ({ ...prev, bank: "" }));
  }
}}
            >
              <option value="">Select Bank</option>
              {bankList.data.map((bank) => (
                <option key={bank.bank_id} value={bank.bank_id}>
                  {bank.bank_name}
                </option>
              ))}
            </select> */}

            {/* {impsType === "IMPS1" && (
              <>
                <select
                  value={selectedBankId}
                  onChange={(e) => {
                    const value = e.target.value;

                    if (!value) {
                      setSelectedBankId("");
                      setSelectedBankName("");
                      setSelectedBankIfsc("");
                      return;
                    }

                    const bank = bankList.data.find(
                      (b) => b.bank_id === value
                    );

                    if (bank) {
                      setSelectedBankId(bank.bank_id);
                      setSelectedBankName(bank.bank_name);
                      setSelectedBankIfsc(bank.bank_ifsc);
                      setErrors((prev) => ({ ...prev, bank: "" }));
                    }
                  }}
                  className="w-full border rounded-lg px-4 py-2"
                >
                  <option value="">Select Bank</option>
                  {bankList.data.map((bank) => (
                    <option key={bank.bank_id} value={bank.bank_id}>
                      {bank.bank_name}
                    </option>
                  ))}
                </select>

                {errors.bank && (
                  <p className="text-red-500 text-xs mt-1">
                    {errors.bank}
                  </p>
                )}
              </>
            )} */}

            {impsType === "IMPS1" && (
              <div className="relative">
                {/* SEARCH INPUT */}
                <input
                  type="text"
                  value={bankSearch}
                  placeholder="Search bank name"
                  onFocus={() => setShowBankList(true)}
                  // onChange={(e) => {
                  //   setBankSearch(e.target.value);
                  //   setShowBankList(true);
                  //   setErrors((prev) => ({ ...prev, bank: "" }));
                  // }}
                  onChange={(e) => {
                    const value = e.target.value;
                    setBankSearch(value);
                    setShowBankList(true);
                  }}
                  className="w-full border rounded-lg px-4 py-2 focus:ring-2 focus:ring-indigo-500"
                />

                {/* DROPDOWN LIST */}
                {showBankList && (
                  <div className="absolute z-20 mt-1 w-full max-h-60 overflow-y-auto
                      bg-white border rounded-lg shadow-lg">
                    {bankList.data
                      .filter((bank) =>
                        bank.bank_name
                          .toLowerCase()
                          .includes(bankSearch.toLowerCase())
                      )
                      .map((bank) => (
                        <div
                          key={bank.bank_id}
                          onClick={() => {
                            setSelectedBankId(bank.bank_id);
                            setSelectedBankName(bank.bank_name);
                            setSelectedBankIfsc(bank.bank_ifsc);

                            setBankSearch(bank.bank_name);
                            setShowBankList(false);
                            setErrors((prev) => ({ ...prev, bank: "", ifscCode: "" }));
                          }}
                          className="px-4 py-2 cursor-pointer hover:bg-indigo-50 text-sm"
                        >
                          {bank.bank_name}
                        </div>
                      ))}

                    {bankList.data.filter((bank) =>
                      bank.bank_name.toLowerCase().includes(bankSearch.toLowerCase())
                    ).length === 0 && (
                        <div className="px-4 py-2 text-sm text-slate-500">
                          No bank found
                        </div>
                      )}
                  </div>
                )}

                {errors.bank && (
                  <p className="text-red-500 text-xs mt-1">{errors.bank}</p>
                )}
              </div>
            )}

            {errors.bank && (
              <p className="text-red-500 text-xs mt-1">{errors.bank}</p>
            )}
            {errors.ifscCode && (
              <p className="text-red-500 text-xs">{errors.ifscCode}</p>
            )}
          </div>
        </div>

        {/* SECTION: ACCOUNT DETAILS */}
        <div className="mb-6">

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">

            {/* Account Holder Name */}
            <div>
              <label className="block text-sm font-medium text-slate-600 mb-1">
                Account Holder Name
              </label>
              <input
                type="text"
                value={accountHolderName}
                onChange={(e) => handleChange("accountHolderName", e.target.value)}
                placeholder="Account Holder Name"
                className="border rounded-lg px-4 py-2 w-full focus:ring-2 focus:ring-indigo-500"
              />
              {errors.accountHolderName && (
                <p className="text-red-500 text-xs mt-1">
                  {errors.accountHolderName}
                </p>
              )}
            </div>

            {/* Mobile Number */}
            <div>
              <label className="block text-sm font-medium text-slate-600 mb-1">
                Beneficiary Mobile Number
              </label>
              <input
                type="text"
                value={mobileNumber}
                maxLength={10}
                onChange={(e) => handleChange("mobileNumber", e.target.value)}
                placeholder="Beneficiary Mobile Number"
                className="border rounded-lg px-4 py-2 w-full focus:ring-2 focus:ring-indigo-500"
              />
              {errors.mobileNumber && (
                <p className="text-red-500 text-xs mt-1">
                  {errors.mobileNumber}
                </p>
              )}
            </div>

          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-4">

            {/* Account Number */}
            <div>
              <label className="block text-sm font-medium text-slate-600 mb-1">
                Account Number
              </label>
              <input
                type="text"
                value={accountNumber}
                maxLength={20}
                onChange={(e) => handleChange("accountNumber", e.target.value)}
                placeholder="Account Number"
                className="border rounded-lg px-4 py-2 w-full focus:ring-2 focus:ring-indigo-500"
              />
            </div>

            {/* Confirm Account Number */}
            {/* <div>
              <label className="block text-sm font-medium text-slate-600 mb-1">
                Confirm Account Number
              </label>
              <input
                type="text"
                value={confirmAccountNumber}
                maxLength={20}
                onChange={(e) => handleChange("confirmAccountNumber", e.target.value)}
                placeholder="Confirm Account Number"
                className="border rounded-lg px-4 py-2 w-full focus:ring-2 focus:ring-indigo-500"
              />
            </div> */}

          </div>

          {(errors.accountNumber || errors.confirmAccountNumber) && (
            <p className="text-red-500 text-xs mt-2">
              {errors.accountNumber || errors.confirmAccountNumber}
            </p>
          )}
        </div>


        {/* SECTION: SECURITY */}
        <div className="mb-6">
          <h3 className="text-sm font-semibold text-slate-700 mb-4">
            MPIN
          </h3>

          <input
            type="password"
            value={mpin}
            maxLength={6}
            onChange={(e) => handleChange("mpin", e.target.value)}
            placeholder="Enter 6-digit MPIN"
            className="w-full border rounded-lg px-4 py-2 focus:ring-2 focus:ring-indigo-500"
          />
          {errors.mpin && (
            <p className="text-red-500 text-xs mt-1">{errors.mpin}</p>
          )}
        </div>

        {/* {impsType === "IMPS1" && showOtpInput && (
          <div className="mb-6">
            <h3 className="text-sm font-semibold text-slate-700 mb-2">
              OTP Verification
            </h3>

            <input
              type="text"
              value={otp}
              maxLength={6}  // keep 6 (covers both)
              // onChange={(e) => setOtp(e.target.value.replace(/\D/g, ""))}
              onChange={(e) => {
                setOtp(e.target.value.replace(/\D/g, ""));
                setErrors((prev) => ({ ...prev, otp: "" }));
              }}
              placeholder="Enter 4 or 6 digit OTP"
              className="w-full border rounded-lg px-4 py-2 focus:ring-2 focus:ring-indigo-500"
            />

            {errors.otp && (
              <p className="text-red-500 text-xs mt-1">{errors.otp}</p>
            )}
          </div>
        )} */}


        {/* ACTION BUTTONS */}
        <div className="flex justify-end gap-4 pt-4 border-t">
          <button
            type="button"
            onClick={handleCancel}
            className="px-6 py-2 rounded-lg border border-slate-300 text-slate-600 hover:bg-slate-100"
          >
            Cancel
          </button>

          <button
            type="button"
            onClick={handleConfirm}
            disabled={isLoading}
            className={`px-6 py-2 rounded-lg text-white font-semibold
            ${isLoading
                ? "bg-slate-400 cursor-not-allowed"
                : "bg-indigo-600 hover:bg-indigo-700"}`}
          >
            {isLoading ? "Processing..." : "Add Beneficiary"}
          </button>
        </div>
      </div>

      {/* POPUP */}
      {showPopup && (
        <Popup
          message={popupMessage}
          type={popupType}
          onClose={() => {
            setShowPopup(false);
            setNavigateTo(null);
            setNavigateState(null);
          }}
          navigateTo={navigateTo}
          navigateState={navigateState}
          showchildren={false}
        />
      )}
    </div>
  );


};

export default AepsAddBeneficiary;